import type { LoginDto } from '@nestjs-boilerplate/types';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

import { setAuthState } from '@/stores/auth.store';

import { login } from '../api/auth.api';

export function useLogin(redirectTo?: string) {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (data: LoginDto) => login(data),
    onSuccess: (response) => {
      setAuthState(response.accessToken, response.user);
      toast.success('Login successful!');
      // Redirect to account setup if not completed, otherwise to dashboard
      const destination = response.user.accountSetupComplete ? redirectTo || '/' : '/account-setup';
      navigate({ to: destination });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Login failed. Please try again.');
    },
  });
}
